import React from "react";
import MarketingNav from "../components/marketing/MarketingNav";
import Hero from "../components/marketing/Hero";
import ProblemSection from "../components/marketing/ProblemSection";
import HowItWorksSection from "../components/marketing/HowItWorksSection";
import ComplexitySpotlight from "../components/marketing/ComplexitySpotlight";
import RoutingSpotlight from "../components/marketing/RoutingSpotlight";
import AnalyticsSpotlight from "../components/marketing/AnalyticsSpotlight";
import SecurityStrip from "../components/marketing/SecurityStrip";
import PricingPreview from "../components/marketing/PricingPreview";
import MarketingFooter from "../components/marketing/MarketingFooter";

/**
 * The public landing page at `/`, per design-system/landing.md §6.
 *
 * Renders for every visitor, signed in or not — MarketingNav's auth-aware
 * CTA is what changes, not the route. (This replaced App.js's old
 * RootRedirect, which force-redirected signed-in users straight to
 * /dashboard; that behaviour is gone now that there's a real page to show
 * them, matching plan flow C.)
 *
 * RoutingSpotlight and AnalyticsSpotlight were added 2026-08-19, once items
 * 13 and 14 were verified live in production — see each component's own
 * comment for what backs its claims. Don't add a third spotlight the same
 * way for an unshipped feature; that's the exact mistake the original
 * comparison table was cut to avoid.
 *
 * FinalCta was removed 2026-08-31 and PricingPreview now closes the page.
 * It sat immediately below PricingPreview and duplicated it three ways —
 * same CTA label ("Start free trial"), same destination (/signup), same
 * trial microcopy word for word — while both used variant="elevated", so
 * they merged into one background with ~16rem of dead space between two
 * identical asks. Its headline lives on as PricingPreview's title.
 *
 * Note the section backgrounds alternate deliberately: elevated sections
 * (HowItWorks, RoutingSpotlight, PricingPreview) must never end up
 * adjacent, or they read as one section. Check the ordering here before
 * inserting anything new.
 */
export default function Landing() {
  return (
    <div className="overflow-x-hidden bg-rf-bg-primary">
      <MarketingNav />
      <Hero />
      <ProblemSection />
      <HowItWorksSection />
      <ComplexitySpotlight />
      <RoutingSpotlight />
      <AnalyticsSpotlight />
      <SecurityStrip />
      <PricingPreview />
      <MarketingFooter />
    </div>
  );
}
